import React, { useEffect, useRef, useState } from "react";
import "./DepositAmount.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBook, faUpload } from "@fortawesome/free-solid-svg-icons";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import {
  DepositeAmount,
  DepositeAmountWithGateway,
  GetAllDepositHistory,
} from "../../../features/wallet/slice";
import Successfull_strip_modal from "../../Common/Common_Component/Common_Modal/Successfull_strip_modal/Successfull_strip_modal";
import { GETAuthLogin } from "../../../features/auth/Slice";
import { Form } from "react-bootstrap";
import { AppSetup, GetPaymentQr } from "../../../features/admin/common/Slice";
import { IDS } from "../../../utils/IDS";
import useRazorpay from "react-razorpay";

const amounts = ["100", "200", "300", "400", "500", "1K", "2K", "3K", "5K"];

function DepositAmount() {
  const dispatch = useDispatch();

  // ✅ TAB STATE
  const [activeTab, setActiveTab] = useState("gateway");
  const [Razorpay] = useRazorpay();

  const [selectedAmount, setSelectedAmount] = useState("");
  const [preview, setPreview] = useState(null);
  const [depositFile, setDepositFile] = useState(null);
  const [modalShow, setModalShow] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const [depositFileError, setDepositFileError] = useState("");
  const currentAmountRef = useRef(null);

  const appSetup = useSelector((state) => state.common.app_setup);
  const payment_qr = useSelector((state) => state.common.payment_qr);

  useEffect(() => {
    dispatch(AppSetup());
    dispatch(GetPaymentQr());
  }, [dispatch]);

  const {
    register,
    handleSubmit,
    setValue,
    watch,
    reset,
    formState: { errors, isSubmitting },
  } = useForm({
    defaultValues: {
      amount: "",
      utr_number: "",
    },
  });

  const inputValue = watch("amount");

  const handleAmountClick = (amt) => {
    const value = amt.includes("K") ? parseInt(amt) * 1000 : amt;
    setSelectedAmount(amt);
    setValue("amount", value, { shouldValidate: true });
  };

  const clearForm = () => {
    setSelectedAmount("");
    setPreview(null);
    setDepositFile(null);
    setDepositFileError("");
    reset({ amount: "", utr_number: "" });
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setDepositFile(file);
      setPreview(URL.createObjectURL(file));
      setDepositFileError("");
    }
  };

  const onSubmit = async (data) => {
    try {
      if (!depositFile && activeTab === "qr") {
        setDepositFileError("Please upload deposit proof receipt");
        return;
      }
      setDepositFileError("");

      const formData = new FormData();
      formData.append("amount", data.amount);
      formData.append("utr_number", data.utr_number);
      if (depositFile) formData.append("image", depositFile);

      const res = await dispatch(DepositeAmount(formData));

      if (res.meta?.requestStatus === "fulfilled") {
        clearForm();
        setModalMessage(
          res?.payload?.data || "Deposit request submitted successfully",
        );
        setModalShow(true);
        setTimeout(() => setModalShow(false), 3000);

        await dispatch(GETAuthLogin());
        await dispatch(GetAllDepositHistory());
      } else {
        setModalMessage(
          res?.payload?.errors || "Deposit failed. Please try again",
        );
        setModalShow(true);
        setTimeout(() => setModalShow(false), 3000);
      }
    } catch (error) {
      console.error("Deposit error:", error);
    }
  };

  const handleGatewaySubmit = (data) => {
    currentAmountRef.current = data.amount;
    handleRazorpay(data.amount);
  };

  const handleRazorpay = async (price) => {
    const amountInPaise = Math.round(price * 100);
    const options = {
      key: "rzp_test_I05KCFb1v5JJRc",
      amount: amountInPaise,
      currency: "INR",
      name: "Om TApovan",
      description: "Test Transaction",
      image:
        "http://localhost:3000/static/media/hippicart-logo.427718645d3015dbf003.png",

      handler: async (res) => {
        await onDepositSubmit(res.razorpay_payment_id);
      },
      prefill: {
        name: "Prajwal Vaychal",
        email: "youremail@example.com",
        contact: "9999999999",
      },
      notes: {
        address: "Razorpay Corporate Office",
      },
      theme: {
        color: "#052c65",
      },
    };

    const rzpay = new Razorpay(options);
    rzpay.open();
  };

  const onDepositSubmit = async (razorpay_payment_id) => {
    try {
      const formData = new FormData();
      formData.append("payment_id", razorpay_payment_id);
      formData.append("amount", currentAmountRef.current);

      const res = await dispatch(DepositeAmountWithGateway(formData));

      if (res.meta?.requestStatus === "fulfilled") {
        clearForm();
        setModalMessage(res?.payload?.data);
        setModalShow(true);
        setTimeout(() => {
          setModalShow(false);
        }, 3000);
        await dispatch(GETAuthLogin());
        console.log("Deposit successful:", res?.payload?.data);
      } else if (res.meta?.requestStatus === "rejected") {
        setModalShow(true);
        setModalMessage(res?.payload?.errors || "Deposit failed.");
        setTimeout(() => {
          setModalShow(false);
        }, 3000);
        console.error("Deposit rejected:", res?.payload?.errors);
      }
    } catch (error) {
      console.error("Deposit error:", error);
    }
  };

  return (
    <div className="deposit_amount deposit_card_box Modify_Bank_Information">
      <div className="wallet_card">
        <div className="wallet_buttons">
          <button
            className={`wallet_btn ${activeTab === "gateway" ? "active" : ""}`}
            onClick={() => setActiveTab("gateway")}
          >
            UPI / Card / Net Banking
          </button>

          <button
            className={`wallet_btn ${activeTab === "qr" ? "active" : ""}`}
            onClick={() => setActiveTab("qr")}
          >
            Pay & Upload Receipt
          </button>
        </div>
      </div>

      {activeTab === "gateway" && (
        <div className="card_box">
          <div className="section_header">
            <span className="icon_box">
              <FontAwesomeIcon icon={faBook} />
            </span>
            <h4>Deposit Amount</h4>
          </div>

          <form onSubmit={handleSubmit(handleGatewaySubmit)} noValidate>
            <div className="amount_grid">
              {amounts.map((amt, index) => (
                <button
                  key={index}
                  type="button"
                  className={`amount_btn ${selectedAmount === amt ? "active" : ""
                    }`}
                  onClick={() => handleAmountClick(amt)}
                >
                  ₹ {amt}
                </button>
              ))}
            </div>

            <button
              type="submit"
              className={`amount_btn submit_btn mt-3 w-100 ${inputValue ? "active" : ""
                }`}
              disabled={isSubmitting || !inputValue}
            >
              {isSubmitting ? "Processing..." : "Deposit"}
            </button>
          </form>
        </div>
      )}

      {activeTab === "qr" && (
        <div className="card_box">
          <div className="scanner_img_holder">
            <img
              src={IDS.IMG_URL + payment_qr?.image}
              className="scanner_img"
              alt="QR"
            />
          </div>

          <div className="section_header">
            <span className="icon_box">
              <FontAwesomeIcon icon={faBook} />
            </span>
            <h4>Deposit Amount</h4>
          </div>

          <form onSubmit={handleSubmit(onSubmit)} noValidate>

            <div className="amount_grid">
              {amounts.map((amt, index) => (
                <button
                  key={index}
                  type="button"
                  className={`amount_btn ${selectedAmount === amt ? "active" : ""
                    }`}
                  onClick={() => handleAmountClick(amt)}
                >
                  ₹ {amt}
                </button>
              ))}
            </div>
            <Form.Group className="form-group field_holder mb-3">
              <Form.Label>
                Please enter an amount{" "}
                <span className="mandatory_estrics">*</span>
              </Form.Label>

              <div className="amount_input_box">
                <span className="currency">₹</span>
                <input
                  type="number"
                  placeholder="₹100 - ₹50,000"
                  {...register("amount", {
                    required: activeTab === "qr" ? "Please enter an amount" : false,
                    min: { value: 100, message: "Minimum ₹100" },
                    max: { value: 50000, message: "Maximum ₹50,000" },
                  })}
                  onChange={(e) => {
                    setSelectedAmount("");
                    setValue("amount", e.target.value, {
                      shouldValidate: true,
                    });
                  }}
                />
                <span className="clear_btn" onClick={clearForm}>
                  ✕
                </span>
              </div>

              {errors.amount && (
                <small className="text-danger">{errors.amount.message}</small>
              )}
            </Form.Group>
            {" "}
            <Form.Group className="form-group field_holder mb-3">
              {" "}
              <Form.Label>
                {" "}
                UTR Number <span className="mandatory_estrics">*</span>{" "}
              </Form.Label>{" "}
              <div className="">
                {" "}
                <Form.Control
                  type="text"
                  placeholder="Please enter UTR number"
                  {...register("utr_number", {
                    required: activeTab === "qr" ? "UTR Number is required" : false,
                    minLength: {
                      value: 12,
                      message: "UTR must be at least 12 characters",
                    },
                    maxLength: {
                      value: 22,
                      message: "UTR must be at most 22 characters",
                    },
                  })}
                />{" "}
              </div>{" "}
              {errors.utr_number && (
                <small className="text-danger d-block mt-1">
                  {" "}
                  {errors.utr_number.message}{" "}
                </small>
              )}{" "}
            </Form.Group>
            <Form.Group className="form-group field_holder mb-3">
              <Form.Label>
                Deposit Proof Receipt <span className="mandatory_estrics">*</span>
              </Form.Label>
              <div className="upload_box">
                <input
                  type="file"
                  id="depositProof"
                  hidden
                  accept="image/*"
                  onChange={handleFileChange}
                />
                <label className="photo_label" htmlFor="depositProof">
                  {preview ? (
                    <img src={preview} alt="Preview" className="uploaded_img_preview" />
                  ) : (
                    <>
                      <FontAwesomeIcon icon={faUpload} /> <span>Upload</span>
                    </>
                  )}
                </label>
              </div>
              {depositFileError && (
                <small className="text-danger d-block mt-1">{depositFileError}</small>
              )}
            </Form.Group>
            <button
              type="submit"
              className={`amount_btn submit_btn w-100 ${inputValue ? "active" : ""
                }`}
              disabled={isSubmitting || !inputValue}
            >
              {isSubmitting ? "Processing..." : "Deposit"}
            </button>
          </form>
        </div>
      )}


      <Successfull_strip_modal
        show={modalShow}
        onHide={() => setModalShow(false)}
        textMsg={modalMessage}
      />
    </div>
  );
}

export default DepositAmount;